import * as React from 'react';
import { currencyText, parameterizedString } from '../utils';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const {
  DIRECTORY_THEME,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);

const $ST = DIRECTORY_THEME.CHECKOUT_SUMMARY;

export default class CheckoutSummary extends React.Component {
  constructor(props) {
    super(props);
    this.renderDiscounts = this.renderDiscounts.bind(this);
  }

  renderDiscounts() {
    return (
      this.props.discounts &&
      this.props.discounts.map((discount, index) => {
        return (
          <div className='discount' key={index}>
            <p>{discount.description}</p>
            <p>
              -{discount.discount} {currencyText(this.props.currency_type)}
            </p>
          </div>
        );
      })
    );
  }

  renderShippingAmount() {
    const { shipping_option } = this.props;
    if (shipping_option) {
      return (
        <div className='discount'>
          <p>{shipping_option.name}</p>
          <p>
            {shipping_option.shipping_amount}{' '}
            {currencyText(this.props.currency_type)}
          </p>
        </div>
      );
    }
    return false;
  }

  calculateTotalPriceWithInstallment = () => {
    const { cardId, installmentId, installmentOptions } = this.props;
    const card =
      installmentOptions &&
      installmentOptions.find((item) => item.pk === cardId);

    if (card && card.installments && card.installments.length > 0) {
      const installment = card.installments.find(
        (installment) => installment.pk === installmentId
      );
      return installment && installment.price_with_accrued_interest;
    }
    return null;
  };

  render() {
    const {
      total_amount,
      total_product_amount,
      total_product_count,
      installmentId,
    } = this.props;

    const totalPriceWithInstallment = this.calculateTotalPriceWithInstallment();

    return (
      <div className='checkout-summary'>
        <div className='title'>
          {parameterizedString($ST.ORDER_SUMMARY, total_product_count)}
        </div>
        <div className='desc'>
          <div className='expense'>
            {['Lacoste Instore'].includes($A.TITLE) 
              ? (<p>{total_product_count} {$ST.PRODUCT}</p>)
              : (<p>{$ST.PRODUCTS}</p>)
            }
            <p className='total'>
              {installmentId ? totalPriceWithInstallment : total_product_amount}{' '}
              {currencyText(this.props.currency_type)}
            </p>
          </div>
          {this.renderDiscounts()}
          {this.renderShippingAmount()}
          <div className='amount'>
            <p>{$ST.TOTAL}</p>
            <p className='total'>
              {installmentId ? totalPriceWithInstallment : total_amount}{' '}
              {currencyText(this.props.currency_type)}
            </p>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/checkout/CheckoutSummary.js